<!--
 * @Author: your name
 * @Date: 2020-06-29 16:10:51
 * @LastEditTime: 2020-08-11 17:45:06
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \heating-wechat-web\src\components\Index\Index.vue
--> 
<template>
  <div
    class="bindingInfo-wrap"
    v-loading="loading"
    element-loading-text="正在查询您的缴费资格，请稍等"
  >
    <div class="bindingInfo-back"></div>
    <div class="bindingInfo-top">
      <div class="bindingInfo-box">
        <div style="color: #007b83">供热卡号</div>
        <div style="margin-top: 0.15rem">
          <input
            type="text"
            v-model="cardCode"
            style="border-bottom: 1px solid #dddddd; padding-bottom: 0.1rem"
            placeholder="请输入供热卡号"
            class="cardCode-input"
          />
        </div>
      </div>
    </div>
    <div class="bindingInfo-button">
      <el-button
        type="primary"
        style="background: rgba(0, 123, 131, 1); border: none; width: 72%; padding: 4%"
        @click="getPayInfo"
        >{{ routerName ? '绑定并继续' : '绑定' }}</el-button
      >
    </div>
    <div class="mark-hint" v-if="markFlag">
      <div>
        <div style="text-align: right; padding: 0.1rem 0.15rem; color: #aaaaaa">
          <i class="iconfont iconguanbi" @click="markFlag = false"></i>
        </div>
        <div style="color: #007b83; margin-top: 0.14rem">
          <div>
            <div>{{ textHint }}</div>
            <div>请重新检查您的信息~</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'bindingInfo',
  data() {
    return {
      cardCode: '', // 卡号
      loading: false, // 防抖加载
      markFlag: false, // 提示信息弹窗
      textHint: '', // 文字提示
      routerName: '', // 要跳转的路由
    };
  },

  methods: {
    // 查询缴费资格
    async getPayInfo() {
      if (!this.cardCode) {
        this.markFlag = true;
        return (this.textHint = '抱歉，您的供热卡号未填写');
      }
      const res = await this.$http.post(`${this.$url.globalurl}/wxUser`, {
        heating_card_num: this.cardCode,
      });
      console.log(res);
      if (res.result.fail) {
        this.markFlag = true;
        return (this.textHint = res.result.message);
      } else {
        if (this.routerName) {
          if (this.routerName === 'ownerMessage') {
            // 办理续停资格
            const res = await this.$http.get(this.$url.globalurl + '/wxContinueStop/0');
            if (res.code === 200) {
              if (!res.result) {
                // 不符合办理续停条件
                this.$router.replace({
                  name: 'searchHint',
                  query: {
                    noContinueStop: true,
                  },
                });
                return;
              }
            }
          } else if (this.routerName === 'searchResult') {
            // 供暖缴费
            const res = await this.$http.get(this.$url.globalurl + '/wxPayMent/0');
            if (res.code === 200) {
              if (!res.result.can_paid) {
                // 没有交费资格
                this.$router.replace({
                  name: 'searchHint',
                  query: {
                    payFlag: true,
                    payTime: res.result.time,
                    message: res.result.message,
                  },
                });
                return;
              }
            }
          } else if (this.routerName === 'heatMetering') {
            // 热计量公示
            this.$router.push({
              name: 'heatMetering',
            });
            return;
          } else {
            // 跑漏险保险
            const res = await this.$http.get(this.$url.globalurl + '/wxPayMent/0', {
              data: {
                risk: true,
              },
            });
            if (res.code === 200) {
              if (!res.result.can_paid) {
                // 没有交费资格
                this.$router.replace({
                  name: 'searchHint',
                  query: {
                    payFlag: false,
                    payTime: res.result.time,
                  },
                });
                return;
              }
            }
          }
          // 跳转
          this.$router.replace({
            name: this.routerName,
            query: {
              cardCode: this.cardCode,
              userName: res.result.owner_name,
            },
          });
        } else {
          this.$router.replace({
            name: 'index',
          });
        }
      }
    },
    // 缴费记录跳转
    getPayRecord() {
      this.$router.push({
        name: 'payRecord',
        query: {
          insuranceFlag: false,
        },
      });
    },
  },
  mounted() {
    if (this.$route.query) {
      this.cardCode = this.$route.query.cardCode;
      this.routerName = this.$route.query.routerName;
    }
    let title = this.$route.query.flag ? '修改绑定' : '房屋绑定';
    document.title = title;
  },
};
</script>
<style lang='scss' scoped>
@import url(bindingInfo.scss);
</style>
